import { useState, useEffect } from 'react';
import { Cookie, X } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show banner after a short delay
      setTimeout(() => setShowBanner(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-fade-in">
      <Card className="max-w-4xl mx-auto border-2 border-primary/30 shadow-2xl bg-card/95 backdrop-blur-lg">
        <CardContent className="p-6">
          <div className="flex items-start gap-4">
            {/* Cookie Icon */}
            <div className="bg-primary/10 text-primary p-3 rounded-full shrink-0">
              <Cookie className="w-6 h-6" />
            </div>

            {/* Content */}
            <div className="flex-1 space-y-4">
              <div>
                <h3 className="text-lg font-semibold mb-2">Cookie-Einstellungen / Cookie Settings</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  <strong>DE:</strong> Wir verwenden nur technisch notwendige Cookies, um die Funktionalität dieser Website zu gewährleisten. 
                  Es werden keine Tracking- oder Marketing-Cookies verwendet. Durch die Nutzung dieser Website stimmen Sie der Verwendung 
                  technisch notwendiger Cookies zu.
                </p>
                <p className="text-sm text-muted-foreground leading-relaxed mt-2">
                  <strong>EN:</strong> We only use technically necessary cookies to ensure the functionality of this website. 
                  No tracking or marketing cookies are used. By using this website, you agree to the use of technically necessary cookies.
                </p>
                <div className="mt-3">
                  <a 
                    href="/privacy" 
                    className="text-sm text-primary hover:underline font-medium"
                  >
                    Datenschutzerklärung / Privacy Policy
                  </a>
                  {' • '}
                  <a 
                    href="/impressum" 
                    className="text-sm text-primary hover:underline font-medium"
                  >
                    Impressum / Legal Notice
                  </a>
                </div>
              </div>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-3">
                <Button
                  onClick={handleAccept}
                  className="bg-gradient-to-r from-primary via-secondary to-accent text-white"
                >
                  Akzeptieren / Accept
                </Button>
                <Button
                  onClick={handleDecline}
                  variant="outline"
                  className="border-2"
                >
                  Nur notwendige / Only Necessary
                </Button>
              </div>
            </div>

            {/* Close Button */}
            <button
              onClick={handleDecline}
              className="shrink-0 p-2 hover:bg-accent/10 rounded-full transition-colors"
              aria-label="Close"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default CookieConsent;
